module.exports = __webpack_public_path__ + "img/fulfil-promise-illustration.e18ffa62.svg";